import { computed, inject, Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { valueMaxDistanceSliderMap } from '../../../../utils/value-max-distance-slider-map';
import { RegisterUserFormService } from '../../../../services/register-user-form.service';

@Injectable({
  providedIn: 'root'
})
export class MaxDistanceFieldService {
  
  private _registerUserFormService = inject(RegisterUserFormService);

  private readonly _maxDistanceWalking = computed(() => {
    return this._registerUserFormService.maxDistanceWalking();
  });

  /**
   * Gets the current max distance walking value
   * @returns Current max distance walking value
   */
  getCurrentMaxDistanceWalking() {
    return this._maxDistanceWalking;
  }

  /**
   * Handles slider max distance change event
   * @param sliderValue - The slider value from the event
   * @param control - The form control to update
   */
  handleSliderMaxDistanceChange(sliderValue: number, control: AbstractControl | null): void {
    const maxDistance = valueMaxDistanceSliderMap(sliderValue);
    this._registerUserFormService.setMaxDistanceWalking(maxDistance);
    control?.setValue(maxDistance);
  }

  /**
   * Handles max distance walking label click event
   * @param value - The selected distance value
   * @param control - The form control to update
   */
  handleMaxDistanceWalkingLabelClick(value: number, control: AbstractControl | null): void {
    this._registerUserFormService.setMaxDistanceWalking(value);
    control?.setValue(value);
  }

  /**
   * Maps a distance value to its corresponding slider value
   * @param value - The distance value to map
   * @returns The corresponding slider value
   */
  mapValueToSliderValue(value: number): number {
    switch (value) {
      case 200:
        return 10;
      case 500:
        return 20;
      case 1000:
        return 30;
      case 2000:
        return 40;
      case 3000:
        return 50;
      default:
        return 0;
    }
  }
}
